
import { Component, Input } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-header",
  imports: [MatDialogModule],
  templateUrl: "./dialog-header.component.html",
  styleUrl: "./dialog-header.component.scss",
})
export class DialogHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input() showCloseButton = true;
  @Input() disabled = false;

  constructor(private dialogRef: MatDialogRef<any>) {}

  close(): void {
    this.dialogRef.close();
  }
}
